import { client } from '../../../../../common-utils/libraries/axios/axios';
import { ORGANIZATION } from '../apiUrls';
import { replaceParameters } from '../../../../../common-utils/functions/restUtils';
import organizationFields from '../../fields/organizationFields';
import getObjectAttributeFromStringKey from '@/common-utils/functions/getObjectAttributeFromStringKey';
import generateNestedFieldAccessor from '@/common-utils/functions/generateNestedFieldAccessor';
/**
 * @param root0 response.data object
 * @param root0.uuid
 * @param root0.type
 * @param root0.registrationNumber
 * @param root0.legalName
 * @param root0.address
 * @param root0.contact
 * @param root0.comment
 * @param root0.legalInfos
 * @param root0.clientCode
 * @param root0.brand
 * @param root0.connectionPoints
 * @param root0.provider
 * @param root0.createdAt
 * @param root0.updatedAt
 * @param root0.shouldBlockNewPOS
 * @param root0.pushPaymentEmitterPartners
 * @param response
 * @returns Mapped data object
 */
function mapResponseData(response) {
    const data = {};

    data[organizationFields.UUID.key] = response[organizationFields.UUID.key];
    data[organizationFields.TYPE.key] = response[organizationFields.TYPE.key];
    data[organizationFields.BILLABLE.key] = response[organizationFields.BILLABLE.key];
    data[organizationFields.BILLING_ID_READ.key] = response[organizationFields.BILLING_ID_READ.key];
    data[organizationFields.REGISTRATION_NUMBER.key] = response[organizationFields.REGISTRATION_NUMBER.key];
    data[organizationFields.LEGAL_NAME.key] = response[organizationFields.LEGAL_NAME.key];
    data[organizationFields.ADDRESS.key] = response[organizationFields.ADDRESS.key];
    data[organizationFields.CONTACT.key] = response[organizationFields.CONTACT.key];
    data[organizationFields.COMMENT.key] = response[organizationFields.COMMENT.key];
    data[organizationFields.LEGAL_INFOS.key] = response[organizationFields.LEGAL_INFOS.key]; //parent keys
    data[organizationFields.CLIENT_CODE.key] = response[organizationFields.CLIENT_CODE.key];
    data[organizationFields.BRAND.key] = response[organizationFields.BRAND.key]; //parent keys
    data[organizationFields.CONNECTION_POINTS.key] = response[organizationFields.CONNECTION_POINTS.key]; //parent keys
    data[organizationFields.PROVIDER_UUID.key] = response[organizationFields.PROVIDER_UUID.key];
    data[organizationFields.PROVIDER_BRAND.key] = {
        [organizationFields.PROVIDER_BRAND.DOMAIN_NAME.key]:
            getObjectAttributeFromStringKey(response, generateNestedFieldAccessor(organizationFields.PROVIDER_BRAND.DOMAIN_NAME))
    };
    data[organizationFields.CREATED_AT.key] = response[organizationFields.CREATED_AT.key];
    data[organizationFields.UPDATED_AT.key] = response[organizationFields.UPDATED_AT.key];
    data[organizationFields.SHOULD_BLOCK_NEW_POS.key] = response[organizationFields.SHOULD_BLOCK_NEW_POS.key];
    data[organizationFields.PUSH_PAYMENT_PARTNERS.key] = response[organizationFields.PUSH_PAYMENT_PARTNERS.key]; //parent keys

    return data;
}

const queryGetOrganization = (organizationId, enabled) => {
    return {
        queryKey: [ORGANIZATION.DETAILS.queryKey, organizationId],
        queryFn: async () => {
            const response = await client.get(replaceParameters(ORGANIZATION.DETAILS.url, { organizationId: organizationId }));
            return mapResponseData(response.data);
        },
        enabled: enabled
    };
};

export default queryGetOrganization;